/**
 * WF6: Template Selection Wizard
 * SME user selects industry template to start plan
 */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const TemplateSelector = () => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchTemplates();
  }, []);

  const fetchTemplates = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/api/plan-templates`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setTemplates(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
    }
  };

  const selectTemplate = async (template) => {
    // In production, this would create a plan from template
    alert(`Template selected: ${template.name}. This will create a new plan.`);
    // navigate('/plan/create?template=' + template.id);
  };

  const getIndustryIcon = (industry) => {
    const icons = {
      'manufacturing': '🏭',
      'trading': '📦',
      'services': '💼',
      'agriculture': '🌾'
    };
    return icons[industry] || '🏢';
  };

  if (loading) return <div className="p-8">Loading templates...</div>;

  return (
    <div className="p-8">
      <div className="mb-8 text-center">
        <h1 className="text-4xl font-bold text-gray-900 mb-2">Choose Your Industry</h1>
        <p className="text-gray-600 text-lg">Select a template to start your business plan</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
        {templates.map((template) => (
          <div
            key={template.id}
            onClick={() => selectTemplate(template)}
            className="bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all cursor-pointer transform hover:scale-105 p-6 border-2 border-transparent hover:border-blue-500"
          >
            <div className="text-center">
              <div className="text-6xl mb-4">{getIndustryIcon(template.industry)}</div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">{template.name}</h3>
              <div className="text-sm text-gray-600 mb-4 capitalize">{template.industry}</div>
              <div className="text-xs text-gray-500">
                {template.sections?.length || 0} sections
              </div>
              <div className="text-xs text-gray-500">
                {template.completeness_threshold}% completeness required
              </div>
              <button className="mt-4 w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700">
                Select Template
              </button>
            </div>
          </div>
        ))}
      </div>

      {templates.length === 0 && (
        <div className="text-center py-12 text-gray-500">
          No templates available. Contact administrator.
        </div>
      )}

      <div className="mt-12 max-w-4xl mx-auto">
        <div className="bg-blue-50 rounded-lg p-6 border border-blue-200">
          <h3 className="font-bold text-blue-900 mb-2">ℹ️ What happens next?</h3>
          <ul className="text-sm text-blue-800 space-y-1">
            <li>• You'll be guided through each section step-by-step</li>
            <li>• Financial projections will be auto-calculated</li>
            <li>• AI will help generate your executive summary</li>
            <li>• Your plan must be 90% complete before submission</li>
            <li>• Bank will review and provide feedback</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TemplateSelector;